import React from "react";
import PropTypes from "prop-types";
import { ValueDataHeading } from "../../style";

const Note = (props) => (
  <div className="flex mb-25">
    <ValueDataHeading>NOTE:&nbsp;</ValueDataHeading>
    {props.children}
  </div>
);

Note.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.elementType
  ]).isRequired,
};

export default Note;
